import { Check, Close, ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails } from '@mui/material';
import { memo, useState, useCallback } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import MarriageForm from './form';
import { AccordionTitle } from 'shell/components/shared/accordion-title';
import {
  AccordionMarriage,
  RegistrationMarriageFormVM,
} from 'mutation/view-models/registration-marriage';
import SearchMarriageForm from './search';

interface MarriageProps {
  disabled?: boolean;
  isEditMode?: boolean;
  editSipoUrl?: string;
}

const MarriageComponent = ({
  disabled,
  isEditMode,
  editSipoUrl,
}: MarriageProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(false);

  const formContext = useFormikContext<RegistrationMarriageFormVM>();

  const onFieldMarriageChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('marriage', {
        ...formContext.values.marriage,
        [key]: value,
      });
    },
    [formContext.values.marriage, formContext.setFieldValue]
  );

  const onFieldsMarriageChange = useCallback(
    (values) => {
      formContext.setFieldValue('marriage', {
        ...formContext.values.marriage,
        ...values,
      });
    },
    [formContext.values.marriage, formContext.setFieldValue]
  );

  const onFieldMarriageSearchChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('searchMarriage', {
        ...formContext.values.searchMarriage,
        [key]: value,
      });
    },
    [formContext.values.searchMarriage, formContext.setFieldValue]
  );

  const onChangeValues = useCallback(
    (values) => {
      formContext.setValues({
        ...formContext.values,
        ...values,
      });
    },
    [formContext.values, formContext.setValues]
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-marriage-content"
        id="panel-person-marriage-header"
        expandIcon={<ExpandMore />}
      >
        {formContext.errors.marriage ? <Close color="error" /> : <Check color="success" />}
        <AccordionTitle isEditMode={isEditMode}>Matrimonio</AccordionTitle>
      </AccordionSummary>
      <AccordionDetails>
        <SearchMarriageForm
          values={formContext.values.searchMarriage}
          onChange={onFieldMarriageSearchChange}
          onChangeValues={onChangeValues}
          disabled={disabled}
          editSipoUrl={editSipoUrl}
          marriageData={formContext.values.marriage}
        />
        <MarriageForm
          disabled={disabled}
          values={formContext.values.marriage}
          onChange={onFieldMarriageChange}
          onChangeValues={onFieldsMarriageChange}
          isEditMode={isEditMode}
          errors={formContext.errors.marriage as FormikErrors<AccordionMarriage>}
          touched={formContext.touched.marriage as unknown as FormikTouched<AccordionMarriage>}
        />
      </AccordionDetails>
    </Accordion>
  );
};

MarriageComponent.displayName = 'Accordion marriage component';

const Marriage = memo(MarriageComponent);

export default Marriage;
